import React, { useEffect, useState, useRef } from "react";
import { Container } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import { Card, CardBody, Row, Col, Input, Spinner, Button } from "reactstrap";
import PrintPriceTagsGrid from "./PrintPriceTagsGrid";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { getStoreSettings as onGetStoreSettings } from "store/products/actions";
import { getAllProducts as onGetAllProducts } from "store/products/actions";
import { showSuccessToast } from "helpers/function_helper";
import {
  getPurchaseEntryList,
  getPurchaseEntryForEditDirect,
  getProductForEditDirect,
} from "helpers/backend_helper";
import { differenceWith, isEqual, map, find } from "lodash"

const PrintPriceTag = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    dispatch(onGetAllProducts());
    dispatch(onGetStoreSettings(true));
    getAllPurchaseEntries();
  }, [dispatch]);

  const {
    match: { params },
  } = props;

  useEffect(() => {
    if (params && params.id) {
      setSelectedProductId(params.id);
      getAllDetails(params.id);
    }
  }, []);

  const messagesEndRef = useRef(null);
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  };
  const [purchaseEntryList, setPurchaseEntryList] = useState([]);
  const [purchaseRows, setPurchaseRows] = useState([]);
  const [productDetails, setProductDetails] = useState({});
  const [selectedProductId, setSelectedProductId] = useState();
  const [productFilteredList, setProductFilteredList] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedPurchaseEntries, setSelectedPurchaseEntries] = useState(null);
  const [printQuantity, setPrintQuantity] = useState(1);
  const [emptyColumns, setEmptyColumns] = useState(0);
  const [priceTagList, setPriceTagList] = useState([]);

  const [showLoading, setShowLoading] = useState(false);
  const [purchaseEntryLoading, setPurchaseEntryLoading] = useState(false);
  const [mappingMap, setMappingMap] = useState();
  const [currentPurchaseEntries, setCurrentPurchaseEntries] = useState([]);

  const { settings, productList } = useSelector((state) => ({
    productList: state.Products.products,
    settings: state.Products.settings,
  }));

  function parseMapping(mappingString) {
    const mappings = {};
    const pairs = mappingString.split(",");
    pairs.forEach((pair) => {
      const [digit, letter] = pair.split("=");
      mappings[digit] = letter;
    });
    return mappings;
  }

  function getAllDetails(productid) {
    getProductDetailsFromId(productid);
  }

  async function getAllPurchaseEntries() {
    setPurchaseEntryLoading(true);
    getPurchaseEntryList().then((result) => {
      setPurchaseEntryList(result);
      setPurchaseEntryLoading(false);
    });
  }

  async function getPurchaseEntryDetails(pEntryId) {
    setShowLoading(true);
    const response = await getPurchaseEntryForEditDirect(pEntryId);
    if (response && response.status === "failure") {
      //setShowErrorPopUp(true)
      //setErrorMessage(response.errorResponse)
    } else if (response && response.purchaseRows) {
      //setPurchaseRows(response.purchaseRows);
      
      const newArray = map(response.purchaseRows, (itemA) => {
        const matchingItemB = find(productFilteredList, { productid: itemA.productid });
        if (matchingItemB) {
          return {
            ...matchingItemB,
            totalTags: itemA.productqty,
            mrp: itemA.mrp,
            pRateCode: priceToAlphabeticCode(Number(itemA.rateperitem)),
            pEntryId:pEntryId
          };
        }
        return itemA;
      });
      
      /*
      const newArray = map(productFilteredList, (itemA) => {
        const matchingItemB = find(response.purchaseRows, { productid: itemA.productid });
        console.log('matchingItemB:',matchingItemB)
        if (matchingItemB) {
          return {
            ...itemA,
            totalTags: matchingItemB.productqty,
            pRateCode: priceToAlphabeticCode(Number(itemA.baseprice)),
            pEntryId:pEntryId
          };
        }
        return itemA;
      });
      */
  
      //setResultArray(newArray);

      setPriceTagList((prevList) => [
        ...prevList,
        ...newArray
      ]);

    }
    setShowLoading(false);
  }

  function getProductDetailsFromId(productid) {
    setShowLoading(true);
    getProductForEditDirect(productid).then((resp) => {
      setProductDetails(resp);
      setShowLoading(false);
    });
  }

  function onChangeOfPurchaseEntries(pEntries){
    const toFetch = differenceWith(pEntries, currentPurchaseEntries, isEqual);
    const toRemove = differenceWith(currentPurchaseEntries, pEntries, isEqual);
    setCurrentPurchaseEntries(pEntries)
    if(toFetch.length>0){
      getPurchaseEntryDetails(toFetch[0].id)
    }

    if(toRemove.length>0){
      const currentList = [...priceTagList]
      const newList = currentList.filter(each=>each.pEntryId != toRemove[0].id)
      setPriceTagList(newList)
    }
  }

  function priceToAlphabeticCode(price) {
    const integerPart = Math.floor(price);
    const integerString = integerPart.toString().padStart(4, '0');
    const alphabeticCode = integerString
      .split("")
      .map((digit) => mappingMap[digit])
      .join("");

    return alphabeticCode;
  }

  useEffect(() => {
    if (settings && settings.length > 0) {
      const priceTagCodes = settings.filter(
        (each) => each.settingid == "DEFAULT_PRICE_TAG_CODES"
      );
      if (priceTagCodes && priceTagCodes.length > 0) {
        const mapping = parseMapping(priceTagCodes[0].settingvalue);
        setMappingMap(mapping);
      }
    }
  }, [settings]);

  useEffect(() => {
    setProductFilteredList(productList);
  }, [productList]);

  function close() {
    history.push("/view-products");
  }

  function isNumber(num) {
    return !!(Number(num) || num == 0);
  }

  function addToTheList() {
    setPriceTagList((prevList) => [
      ...prevList,
      {
        ...productDetails,
        totalTags: printQuantity,
        pRateCode: priceToAlphabeticCode(Number(productDetails.baseprice)),
      },
    ]);
    showSuccessToast("Item added!");
    setProductDetails();
    setSelectedProduct(null);
  }

  function removeItemFromPrint(item) {
    setPriceTagList((prevList) =>
      prevList.filter((each) => each.productid !== item.productid)
    );
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Products" breadcrumbItem="Price Tags" />
          <Card>
            <CardBody className="no-x-padding" style={{ minHeight: "400px" }}>
              <Row className="">
                <Col lg="4">
                  <Row>
                    <Col md="12" className="text-center fw-medium font-size-15">
                      Select the Purchase Entries.
                    </Col>
                    <Col md="12" className="mx-2">
                      <Select
                        onChange={(e) => {
                          setSelectedPurchaseEntries(e);
                            onChangeOfPurchaseEntries(e)
                            //getPurchaseEntryDetails(e.id)
                            //setSelectedProductId(e.productid);
                            //getAllDetails(e.productid);
                        }}
                        isClearable
                        isMulti
                        value={selectedPurchaseEntries}
                        getOptionLabel={(option) =>
                          option.invoicedate + ' / ' +option.suppliername + " / Rs. "+ option.grandtotal
                        }
                        getOptionValue={(option) => option.id}
                        options={purchaseEntryList}
                        classNamePrefix="select2-selection"
                        isLoading={purchaseEntryLoading}
                        id="purchaseEntry"
                      />
                    </Col>
                    <Col md="12" className="mx-2 text-center font-size-15 mt-3 border-bottom border-top">
                      -- OR --
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col className="text-center fw-medium font-size-15">
                      Select the products and add them.
                    </Col>
                  </Row>
                  <div className="mt-2 mb-3 ms-2">
                    <Select
                      onChange={(e) => {
                        setSelectedProduct(e);
                        if (e?.productid) {
                          setSelectedProductId(e.productid);
                          getAllDetails(e.productid);
                        }
                      }}
                      isClearable
                      value={selectedProduct}
                      getOptionLabel={(option) =>
                        option.productcode + " - " + option.productname
                      }
                      getOptionValue={(option) => option.productid}
                      options={productFilteredList}
                      classNamePrefix="select2-selection"
                      isLoading={false}
                      id="productid"
                    />
                  </div>
                  {showLoading ? (
                    <div className=" text-center mt-5">
                      <Spinner
                        style={{ width: "3.2rem", height: "3.2rem" }}
                        className="ms-3"
                        color="primary"
                      />
                    </div>
                  ) : (
                    <div className="ms-3 mt-5">
                      {productDetails?.productname && (
                        <div>
                          <Row className="border-bottom py-2">
                            <Col md="6">Pdt Name</Col>
                            <Col md="6">{productDetails.productname}</Col>
                          </Row>
                          <Row className="border-bottom py-2">
                            <Col md="6">P Rate</Col>
                            <Col md="6">{productDetails.baseprice}</Col>
                          </Row>
                          <Row className="border-bottom py-2">
                            <Col md="6">S Rate</Col>
                            <Col md="6">{productDetails.mrp}</Col>
                          </Row>
                          <Row className="border-bottom py-2">
                            <Col md="6" className="d-flex align-items-center">
                              Quantity
                            </Col>
                            <Col md="6">
                              <Input
                                type="tel"
                                className="form-control"
                                id="printQty"
                                maxLength="2"
                                value={printQuantity || ""}
                                onChange={(e) => {
                                  if (isNumber) {
                                    setPrintQuantity(e.target.value);
                                  }
                                }}
                              />
                            </Col>
                          </Row>
                          <Row className="border-bottom py-2">
                            <Col md="12">
                              <Button
                                color="info"
                                className="btn btn-success px-4"
                                onClick={() => {
                                  if (printQuantity > 0) {
                                    addToTheList();
                                  }
                                }}
                              >
                                Add
                              </Button>
                            </Col>
                          </Row>
                        </div>
                      )}
                    </div>
                  )}
                  {priceTagList && priceTagList.length > 0 && (
                    <div className="ms-3">
                      <Row className="border-bottom border-top py-3">
                        <Col md="6" className="d-flex align-items-center">
                          Empty Columns
                        </Col>
                        <Col md="6">
                          <Input
                            type="tel"
                            className="form-control"
                            id="emptyColumns"
                            maxLength="2"
                            value={emptyColumns}
                            onChange={(e) => {
                              if (
                                isNumber(e.target.value) ||
                                e.target.value == ""
                              ) {
                                setEmptyColumns(e.target.value);
                              }
                            }}
                          />
                        </Col>
                      </Row>
                      <div className="mt-3">
                        {priceTagList.map((each, indx) => (
                          <Row key={indx} className="mb-1">
                            <Col md="8">{each.productname}</Col>
                            <Col md="2">{each.totalTags}</Col>
                            <Col md="2">
                              <Button
                                color="warning"
                                className="btn btn-sm"
                                onClick={() => {
                                  removeItemFromPrint(each);
                                }}
                              >
                                Remove
                              </Button>
                            </Col>
                          </Row>
                        ))}
                      </div>
                    </div>
                  )}
                </Col>
                <Col lg="8">
                  <div>
                    {priceTagList && priceTagList.length > 0 && (
                      <PrintPriceTagsGrid
                        tags={priceTagList}
                        emptyColumns={emptyColumns}
                      />
                    )}
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Container>
      </div>
      <div></div>
    </React.Fragment>
  );
};

export default PrintPriceTag;
